const ClientDashBoard = () =>{

 return (
    <>
    <div>
        welcome to client panel
    </div>
    </>
 )

}

export default ClientDashBoard;